import classNames from 'classnames'

type Props = {
  title: string
  isLoading?: boolean
  disabled?: boolean
  outline?: boolean
  danger?: boolean
  simple?: boolean
  round?: boolean
  handleOnSubmit(): Promise<void> | void
}

export const Button = (props: Props) => {
  const { title, isLoading, disabled, outline, danger, simple, round, handleOnSubmit } = props

  let btnStyle: string = 'btn-primary'
  if (simple) {
    btnStyle = 'btn-simple'
  }
  if (danger) {
    btnStyle = 'btn-danger'
  }

  const classname = classNames('btn', btnStyle, {
    'btn-outline': outline,
    'btn-disabled': disabled,
    'btn-loading': isLoading,
    'btn-round': round,
  })

  return (
    <button disabled={disabled || isLoading} className={classname} onClick={handleOnSubmit}>
      {title}
    </button>
  )
}
